import { getUser } from "../helpers";

const ApiService = {
    serverUrl: "https://ardhmeria.runasp.net/api/",

    fetch: async function (method, url, data) {
 

      var token = await ApiService.getToken();

        var request = {
          method: method,
          // mode: 'no-cors',
          headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
          },
          
        };
    
        if (method == "POST" || method == "PUT" || method == "DELETE") {
          request.body = JSON.stringify(data);
        }

        console.log({token})
        console.log({request})

        return fetch(ApiService.serverUrl + url, request)
          .then(async (response) => {
            if (response.status == 401) {
            
              const promiseA = new Promise((resolutionFunc, rejectionFunc) => {
                resolutionFunc({ Status: 401 });
              });
    
              return promiseA;
            }
            return response.json();
          })
          .catch((error) => {
            console.log(error.message);
          });
      },
      getToken: async function () {

        var userToken = null;

        let user = await getUser();

     

        if(user){
          userToken = user?.user?.token
        }

  
      
        if (userToken != null) {
          return userToken;
        }

    
        return "";
      },
    
      getFetch: function (url, data) {
        return ApiService.fetch("GET", url, data);
      },
      deleteFetch: function (url, data) {
        return ApiService.fetch("DELETE", url, data);
      },
      postFetch: function (url, data) {
        return ApiService.fetch("POST", url, data);
      },
      putFetch: function (url, data) {
        return ApiService.fetch("PUT", url, data);
      },

      deleteFetch: function (url, data) {
        return ApiService.fetch("DELETE", url, data);
      },

      getUser: async function () {
        const userAuth = await localStorage.getItem("user");
    
        if (userAuth) {
            try {
                const parsedUser = JSON.parse(userAuth);
                // Ensure the parsed object contains the expected structure
                if (parsedUser && typeof parsedUser === 'object') {
                    return parsedUser;
                }
            } catch (error) {
                console.error("Error parsing userAuth from localStorage", error);
            }
        }
    
        return null;
    },
    
    
    
}  

export { ApiService as default };